export const Types = {
    SAVE_LIST_MERCHANT: 'SAVE_LIST_MERCHANT',
    SAVE_MERCHANT_DETAIL: 'SAVE_MERCHANT_DETAIL',
}